import React from 'react'

import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'

import { useShouldRemoveMerchandisingBanner } from '../useShouldRemoveMerchandisingBanner'
import { MerchandisingHeader } from './MerchandisingHeader'
import { getLegacyMerchandisingHeaderContentBlock } from './getLegacyMerchandisingHeaderContentBlock'

const CollectionHeaderWrapper = () => {
  const currentCollectionId = useCurrentCollectionId()
  const collection = useCollection(currentCollectionId)
  const merchandisingHeader = getLegacyMerchandisingHeaderContentBlock(collection?.merchandising)
  const removeMerchandisingBanner = useShouldRemoveMerchandisingBanner()

  if (!merchandisingHeader || removeMerchandisingBanner) {
    return null
  }

  return <MerchandisingHeader header={merchandisingHeader} />
}

export { CollectionHeaderWrapper }
